import Vue from 'vue';
import App from './App.vue';
import router from './router';
import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';
import Noty from 'noty';

window.axios = axios;
window.$ = $;

Vue.config.productionTip = false;

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  //window.NProgress.done();
});

window.axios.interceptors.response.use(
  function(response) {
    // document.getElementById("preloader").style.display = "none";
    // Do something with response data
    //window.NProgress.done();
    return response;
  },
  function(error) {
    //window.NProgress.done();
    // document.getElementById("preloader").style.display = "none";
    if (error.response) {
      if (error.response.status == 401) {
        router.replace({ path: '/' });
      } else if (error.response.status == 413) {
        new Noty({
          text: 'حجم فایل زیاد میباشد',
          timeout: 2500,
          layout: 'topLeft',
          type: 'error',
        }).show();
      }
    }
    // Do something with response error
    return Promise.reject(error);
  },
);
window.axios.interceptors.request.use(
  config => {
    // add
    // document.getElementById("preloader").style.display = "block";
    // app.nprogress.start();
    //window.NProgress.start();
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

window.notif = ({ mssg, isError }) => {
  new Noty({
    text: mssg,
    timeout: 2500,
    layout: 'topLeft',
    type: isError ? 'error' : 'success',
  }).show();
};

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
